import React from 'react';
import AppBar from '../../components/AppBar';
import Footer from '../../components/Footer';
import Affiliate from '../Sections/AffiliateSection';

const AffiliatePage = () => {
  return (
    <>
      <AppBar />
      <Affiliate />
      <Footer />
    </>
  );
};

export default AffiliatePage;
